import React, { useMemo, useState, useEffect } from "react";
import { Box, Switch, FormControlLabel, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import LabeledDateTimePicker from "./LabeledDateTimePicker";
import { useTranslation } from "react-i18next";
import { MIN_SCHEDULE_MINUTES, MIN_SCHEDULE_MS, getMinScheduleDateTime } from "../../constants/scheduleConfig";

const ScheduleSection = ({ 
  isScheduled, 
  setIsScheduled, 
  scheduleDateTime, 
  setScheduleDateTime, 
  loading,
  hideToggle = false
}) => {
  const { t } = useTranslation();
  const theme = useTheme();
  
  // 현재 시간을 지속적으로 추적
  const [currentTime, setCurrentTime] = useState(new Date());
  
  // 매분마다 현재 시간 업데이트
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime(new Date());
    }, 60000); // 1분마다 업데이트
    
    return () => clearInterval(interval);
  }, []);
  
  // Calculate minimum date/time (current time + MIN_SCHEDULE_MINUTES)
  const minDateTime = useMemo(() => {
    return new Date(currentTime.getTime() + MIN_SCHEDULE_MS);
  }, [currentTime]);
  
  // Handle date/time changes with validation
  const handleDateTimeChange = (newDateTime) => {
    if (newDateTime && newDateTime < minDateTime) {
      // If selected time is less than MIN_SCHEDULE_MINUTES from now, set to minimum time
      setScheduleDateTime(minDateTime);
    } else {
      setScheduleDateTime(newDateTime);
    }
  };
  
  return (
    <>
      {/* 예약 게시 옵션 */}
      {!hideToggle && (
        <Box 
          sx={{ 
            display: "flex", 
            alignItems: "center", 
            justifyContent: "space-between", 
            width: "100%", 
            marginBottom: theme.spacing(2) 
          }}
        >
          <FormControlLabel
            control={
              <Switch
                checked={isScheduled}
                onChange={(event) => {
                  setIsScheduled(event.target.checked);
                  if (event.target.checked) {
                    // 예약 모드 활성화 시 현재 시간 + MIN_SCHEDULE_MINUTES으로 설정
                    setScheduleDateTime(getMinScheduleDateTime());
                  } else {
                    setScheduleDateTime(new Date());
                  }
                }}
                disabled={loading}
              />
            }
            label={t("postThreads.schedule.title")}
          />
        </Box>
      )}

      {/* 예약 시간 선택 */}
      {isScheduled && (
        <Box>
          {/* 안내 문구 */}
          <Typography 
            variant="body2" 
            sx={{ 
              color: theme.palette.text.secondary,
              fontSize: "0.875rem",
              mb: 1,
              display: "flex",
              alignItems: "center",
              gap: 0.5
            }}
          >
            {t("postThreads.schedule.guidanceText")}
          </Typography>
          
          <LabeledDateTimePicker
            label={t("postThreads.schedule.time")}
            placeholder={t("postThreads.schedule.placeholder")}
            value={scheduleDateTime}
            onChange={handleDateTimeChange}
            disabled={loading}
            minDate={minDateTime}
          />
          
          {/* 최소 시간 안내 */}
          <Typography 
            variant="caption" 
            sx={{ 
              color: theme.palette.text.secondary,
              fontSize: "0.75rem",
              mt: 0.5,
              display: "block"
            }}
          >
            {t("postThreads.schedule.minTimeNotice")}
          </Typography>
        </Box>
      )}
    </>
  );
};

export default ScheduleSection; 